// Instagram functionality is disabled for now, code related to that is commented
import React, { useEffect, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { EmailShareButton, FacebookShareButton } from "react-share";
import { toast } from "react-toastify";
import GoogleGIcon from "../../../images/g-icon.svg";
import CopyLinkIcon from "../../../images/v2/copy-link-icon.svg";
import EmailIcon from "../../../images/v2/email-icon.svg";
import FacebookIcon from "../../../images/v2/facebook-icon.svg";
import InstagramIcon from "../../../images/v2/instagram-icon.svg";
import LockIcon from "../../../images/v2/lock-icon.svg";
import DirectMailIcon from "../../../images/v2/direct-mail-arrow.svg";
import { generateFileName, getUserId } from "../../../helpers/common";
import { shareLocationLongPhrase } from "../../../helpers/shareLocation";
import { USER_TYPE_AGENT } from "../../../constants/common";
import { shareWantAdSocial } from "../../../services/v2/wantAdService";
import InstaShareModal from "../../Common/v2/InstaShareModal";
import ShareCardPreview from "../../../components/Common/v2/ShareCardPreview";
import { getDescriptionText } from "../../../helpers/v2/getPropertyIcons";
import Loader from "../../../components/Common/Loader";
import { getUserType } from "../../../helpers/common";
import {
  getAdTypeTextShare,
  readsAsDemand,
  getPropertyArticle,
  getPropertyTextShare,
} from "../../../helpers/v2/shareWantad";

const ShareCard = ({
  wantAdId,
  isSideCard = false,
  adDetails,
  isWantAdCreated,
  show,
  onHide,
  imageLink,
  shareLink,
  fbLink,
  fromWantAdDetails,
  hideHeader = false,
  locked = false,
  posterPlan,
  shareStatus,
  onRetryShare,
}) => {
  const targetRef = useRef(null);
  const [shareUrl, setShareUrl] = useState(shareLink);
  const [fbUrl, setFbUrl] = useState(fbLink);
  const propertyTextShare = getPropertyTextShare(adDetails);
  const article = getPropertyArticle(propertyTextShare);
  const [imageUrl, setImageUrl] = useState(imageLink);
  const [showInstaShareModal, setShowIInstaShareModal] = useState(false);
  const userType = getUserType();
  const currentUserId = getUserId();
  const adType = _.get(adDetails, "adType", "");
  const adTypeText = adType === "BUY" ? "BUY" : "RENT";

  // For sideCard share buttons will be disabled instead of showing loader
  const disabledBtnClass = !shareUrl && isSideCard ? "disabled-share-btn" : "";
  const isAgent = userType === USER_TYPE_AGENT;
  // For sideCard share buttons loader animation
  const loadingBtnClass = !shareUrl
    ? "share-btn-wrapper loading-pulse"
    : "share-btn-wrapper";

  const generateShareLink = async () => {
    if (!wantAdId || !currentUserId) {
      setShareUrl("");
      setFbUrl("");
      setImageUrl("");
      return;
    }

    try {
      const fbPayload = {
        wantAdId: wantAdId,
        platform: "facebook",
      };
      const response = await shareWantAdSocial(fbPayload);
      setShareUrl(response?.result?.shareUrl || "");
      setFbUrl(response?.result?.facebookShareUrl || "");
      setImageUrl(response?.result?.imageUrl || "");
    } catch (err) {
      console.error("Error generating share links:", err);
      setShareUrl("");
      setFbUrl("");
      setImageUrl("");
    }
  };

  useEffect(() => {
    if (!fromWantAdDetails) generateShareLink();
  }, [wantAdId]);
  useEffect(() => {
    setImageUrl(imageLink);
  }, [imageLink]);
  useEffect(() => {
    setShareUrl(shareLink);
  }, [shareLink]);

  useEffect(() => {
    setFbUrl(fbLink);
  }, [fbLink]);

  const handleInstagramShare = () => {
    toast.success("Link copied to clipboard");
    setShowIInstaShareModal(true);
  };

  const handleViewMoreClick = () => {
    if (!isSideCard) onHide();
  };

  const loadAdTitle = () => {
    return (
      <>
        <h2 className="long-txt-fix">
          {readsAsDemand(_.get(adDetails, "adTitle", "")) ? (
            _.get(adDetails, "adTitle", "")
          ) : (
            <>
              {getAdTypeTextShare(_.get(adDetails, "adType", ""))} {article}{" "}
              {propertyTextShare}{" "}
              {shareLocationLongPhrase(adDetails)} |{" "}
              {_.get(adDetails, "adTitle", "")}
            </>
          )}
        </h2>
      </>
    );
  };

  const handleDownloadCard = async () => {
    try {
      if (imageUrl) {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `share-card-${generateFileName()}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success("Card downloaded successfully");
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      {!hideHeader && <div className="modal-share__header">
        {isSideCard ? (
          <div className="d-flex flex-column align-items-center">
            <h4 className="sidecard-heading text-center">
              {isAgent ? "Expand your sphere with" : "Expand your reach with"}{" "}
              <span className="sidecard-heading-brand">Gitcha.com</span>
            </h4>
            <p className="sidecard-subheading text-center">
              {isAgent
                ? "Just like you’d post a new for-sale listing, share your new Buyer Want-Listing on Gitcha.com with your network."
                : "Share what you’re looking for on social media!"}
            </p>
          </div>
        ) : (
          <h3 className="text-center">
            Share this Want-Listing
          </h3>
        )}

        {/* <>
            <h3 className="text-center">Nice work - Share your ad!</h3>
            <p className="pb-32 text-center">
              Sharing your want-ad to people in your network lets others know
              what you're looking for.
            </p>
          </> */}
      </div>}

      <div
        className="share-yourad-mapwrap"
        style={{
          pointerEvents: shareUrl ? "auto" : "none",
          userSelect: shareUrl ? "auto" : "none",
        }}
      >
        <div ref={targetRef} className="share-yourad-maptop">
          <ShareCardPreview
            adDetails={adDetails}
            isSideCard={isSideCard}
            posterPlan={posterPlan}
          />
          {loadAdTitle()}
          <div className="description">{getDescriptionText(adDetails)}</div>
        </div>

        <div className="share-yourad-mapbtm">
          <a
            href={shareUrl || undefined}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleViewMoreClick}
          >
            View more details here
          </a>
          <img src={GoogleGIcon} />
        </div>
      </div>

      <div
        className="share-yourad-top align-items-start pt-32"
        style={{
          pointerEvents: shareUrl ? "auto" : "none",
          userSelect: shareUrl ? "auto" : "none",
        }}
      >
        <>
          <CopyToClipboard text={shareUrl}>
            <a
              href={void 0}
              role="button"
              className={`${loadingBtnClass} share-btn-wrapper copy-link ${disabledBtnClass}`}
              onClick={() => toast.success("Link copied to clipboard")}
            >
              <div
                className={`share-btn-icon ${isSideCard ? "sidecard-share-btn" : ""
                  }`}
              >
                <img src={CopyLinkIcon} alt="copy-link" />
              </div>
              <span
                className={`share-btn-text ${isSideCard ? "sidecard-share-btn-text" : ""
                  }`}
              >
                Copy Link
              </span>
            </a>
          </CopyToClipboard>

          <div
            className={` ${loadingBtnClass} share-btn-wrapper ${disabledBtnClass}`}
          >
            <EmailShareButton
              url={shareUrl}
              className={`share-btn-icon share-email-btn ${isSideCard ? "sidecard-social-btn" : ""
                }`}
            >
              <img src={EmailIcon} alt="email" />
            </EmailShareButton>
          </div>

          {(!shareUrl || fbUrl) && (
            <div
              className={` ${loadingBtnClass} share-btn-wrapper ${disabledBtnClass}`}
            >
              <FacebookShareButton
                url={fbUrl}
                className={`share-btn-icon border-green share-fb-btn ${isSideCard ? "sidecard-social-btn" : ""
                  }`}
              >
                <img src={FacebookIcon} alt="facebook" />
              </FacebookShareButton>
            </div>
          )}

          {(!shareUrl || imageUrl) && (
            <CopyToClipboard text={shareUrl}>
              <a
                href={void 0}
                role="button"
                className={`${loadingBtnClass} share-btn-wrapper ${disabledBtnClass}`}
                onClick={handleInstagramShare}
              >
                <div
                  className={`share-btn-icon border-green share-insta-btn ${isSideCard ? "sidecard-social-btn" : ""
                    }`}
                >
                  <img src={InstagramIcon} alt="instagram" />
                </div>
              </a>
            </CopyToClipboard>
          )}
          {!shareUrl && !isSideCard && !(shareStatus === "error" && onRetryShare) && (
            <Loader loaderText="" />
          )}

          {!shareUrl && !locked && shareStatus === "error" && onRetryShare && (
            <div className="share-spinner">
              <button type="button" className="btn btn-link" onClick={onRetryShare}>
                Try again
              </button>
            </div>
          )}

          {!shareUrl && isSideCard && !locked && shareStatus !== "error" && (
            <div className="share-spinner">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </>
      </div>

      {/*
      // TODO: Steps will be functioning onboarding flow changes will be done
      <div
        className={`share-yourad-bottom ${
          isSideCard ? "sidecard-footer-wrapper" : ""
        }`}
      >
        <div className="share-yourad-bottom-wrapper">
          <div className="share-yourad-bottom-icon">
            <img src={LockIcon} alt="lock-icon" />
          </div>
          {isSideCard ? (
            <>
              <h4 className=" sidecard-footer text-green">
                Share to Facebook or Instagram to unlock your $50 of free direct
                mail to homeowners!
              </h4>
            </>
          ) : (
            <div className="share-yourad-bottom-text-container">
              <h4 className="text-green">
                Share to Facebook or Instagram to unlock your $50 of free direct
                mail to homeowners!
              </h4>

              <span className="text-green">Complete to unlock</span>
            </div>
          )}

           //---------- For Direct mail bottom section ---------
           <div className="share-yourad-bottom-icon direct-mail-icon">
              <img src={DirectMailIcon} alt="direct-mail-icon" />
            </div>
            <div className="share-yourad-bottom-text-container">
              <h4>
                Direct Mail Farming
              </h4>
              <span>Farm for your buyers via bear printing</span>
            </div>
        </div>
      </div> */}

      {showInstaShareModal && (
        <InstaShareModal
          show={showInstaShareModal}
          hide={() => setShowIInstaShareModal(false)}
          shareLink={shareUrl}
          fbLink={fbUrl}
          imageLink={imageUrl}
          isMobile={false}
          onShare={handleDownloadCard}
        />
      )}
    </>
  );
};

export default ShareCard;
